<app-load-dropdown-data [formName]="formName" [isInvoiceNo]="true" (onPrint)="onPrint($event)" (fillDropdownData)="fillDropdownData()"></app-load-dropdown-data>
<div class="container-fluid d-flex flex-column h-100 px-0 sale_invoice_container">
  <div class="row mx-0">
    <div class="col-3 pe-0 py-0 px-0 ">
      <div class="card card-border ">
        <div class="card-header border py-1 pe-3 gap-2 d-flex align-items-center justify-content-end">
          <div class="d-flex align-items-center justify-content-center f-13">
            <app-button 
              class="" 
              [buttonLabel]="'Create Scheme'" 
              [buttonClass]="'dark_pink_button'"
              [buttonType]="'button'"
              (buttonOutputEvent)="OpenCreateUpdateSchemeSlider()"
              >
              <!-- (buttonOutputEvent)="OpenCreateUpdateSchemePopup('Create')" -->
            </app-button>
          </div>
          <div class="d-flex align-items-center justify-content-center f-13">
            <app-button 
              class="" 
              [buttonLabel]="'Add'" 
              showPlusIconwhite="true" 
              [buttonClass]="'blue_button'"
              [buttonType]="'button'" 
              (buttonOutputEvent)="addDetails()">
            </app-button>
          </div>
        </div>
        <div class="card-body px-0 pt-0 pb-0 ">
          <app-ag-grid 
            id="installment_Entry_report"
            [class]="'all_aggrid_tables position-relative d-block ' + gridDynamicHeightClasses"
            [dataModel]="agGridDataModelInstallmentEntry" 
            (onTextCellClick) = "handleTextClick($event)"
            (gridReady)="onGridProdutListReady($event)"
            [rowHeight]="32"
            >
          </app-ag-grid>
        </div>
        <div class="card-footer  border py-2 pb-4  "></div>
      </div>
    </div>
    <div class="col-9 ps-2 px-0" style="height: calc(100vh - 300px) !important;">
      <div class="card border mb-1 ">
        <div class="card-body pt-0 pb-4  mb-2">
          <div class="row">
            <div 
              class="col-12" 
              *ngIf="isaddDetails">
              <form class="theme-form" ngNativeValidate  #installmentEntry="ngForm" >
                    <div class="row ps-1 mt-2 mb-2">
                      <div class="col-5 d-flex gap-2 mb-2 align-items-center">
                        <label for="" class="f-14 font-semibold  text-gray-color text-nowrap mb-0">
                          Customer Name<span class="text-color-danger">*</span>
                        </label>

                        <div class="col ps-1 w-inherit">
                        <app-custom-select2   
                        [customId]="'customerName'" class="" [formModel]="formModel" (valueChanged)="installmentEntryModel.accountLedgerId=$event;setAddressByAccountLedgerId($event)"
                          [ngClass]="{'custom-select2-border-red':!installmentEntryModel?.accountLedgerId && hasAttemptedSubmit}"
                          (keyEnter)="checkPresentInLedgerList($event)" #customSelect2Component></app-custom-select2>
                        
                        </div>
                        <div class="d-flex">
                          <app-svg-icon name="info" class="cursorPointer "
                            (click)="installmentEntryModel?.accountLedgerId?openCustomerDetailsSlider('Edit'):''">
                          </app-svg-icon>
                        </div>
                        <div class="d-flex  pe-3 align-items-center cursorPointer justify-content-end">
                          <app-svg-icon name="plus_circle" (click)="openCustomerDetailsSlider('Add')"></app-svg-icon>
                        </div>
                        </div>
                      <!-- end custmer -->
                      <div class="col-5 gap-2 d-flex align-items-center mb-2 ">
                        <div class="">
                          <label for="" class="f-14 font-semibold text-gray-color text-nowrap mb-0 w-98px">
                            Scheme Name<span class="text-color-danger">*</span>
                          </label>
                        </div>
                        <div class="col pe-2">
                          <app-select 
                            [options]="getAllDropdownModel.schemeNameDropdown"
                            [selectedValue]="installmentEntryModel?.schemeId"
                            (valueChanged)="installmentEntryModel.schemeId=$event; getDataBuSchemeID($event)"
                            [id]="'schemeId'" 
                            [name]="'scheme'" 
                            [ngClass]="{'select-border-red' :   InstallmentEntryForm?.form?.controls?.scheme?.invalid  && hasAttemptedSubmit}"
                            [isDisabled]="false" 
                            [isRequired]="true"
                            (keydown.enter)="onKeydown($event, 'branch')">
                          </app-select>
                        </div>
                      </div>
                      <!-- end  Scheme Name -->
                      <div class="col-2 gap-2 d-flex align-items-center mb-2">
                          <label for="" class="f-14 font-semibold text-gray-color text-nowrap mb-0">
                            Duration
                          </label>
                        <div class="col ps-2">
                          <app-input 
                            [inputName]="'duration'" 
                            [inputType]="'text'" 
                            [inputId]="'durationId'"
                            [inputValue]="getResponsEntryModel?.durationInFormat"
                            (inputValueEmit)="getResponsEntryModel.durationInFormat=$event" [isRequired]="false"
                            [readOnly]="true">
                          </app-input>
                        </div>
                      </div>
                      <!-- end Duration-->
                      <div class="col-5 pe-4 gap-2 d-flex align-items-center mb-2">
                          <label for="" class="f-14 font-semibold pe-4 text-gray-color text-nowrap mb-0 w-112px">
                            Sales Person
                          </label>
                        <div class="col">
                          <app-select 
                            [options]="getAllDropdownModel?.salePersonDropdown"
                            [selectedValue]="installmentEntryModel?.salePersonId"
                            (valueChanged)="installmentEntryModel.salePersonId=$event;" 
                            [id]="'salesPersonId'"
                            [name]="'salesPerson'" 
                            [ngClass]="{'select-border-red' :   InstallmentEntryForm?.form?.controls?.salesPerson?.invalid  && hasAttemptedSubmit}"
                            [isDisabled]="false" 
                            [isRequired]="false">
                          </app-select>
                        </div>
                      </div>
                      <!-- end sale person -->
                       <div class="col-5 mb-2">
                        <div class="row">
                          <div class="col-6 gap-2 d-flex align-items-center">
                              <label for="JoiningDate" class="f-14 font-semibold pe-2  text-gray-color text-nowrap mb-0 w-98px">
                                Joining Date<span class="text-color-danger">*</span>
                              </label>
                            <div class="col pe-2">
                              <app-input-datepicker-renderer 
                                [inputDatepickerName] = "'joiningDate'"
                                [isRequired]="true"
                                [id]="'joiningDate'" 
                                [inputDate]="installmentEntryModel?.joiningDate"
                                (dateChanged)="selectedRangeDatesjoiningDate($event)">
                              </app-input-datepicker-renderer>
                            </div>
                          </div>
                          <div class="col-6  d-flex align-items-center">
                              <label for="MaturityDate"
                                class="f-14 font-semibold pe-2 text-gray-color text-nowrap mb-0 w-98px">
                                Maturity Date
                              </label>
                            <div class="col pe-2">
                              <app-input 
                              [inputName]="'maturityDate'" 
                              [inputType]="'text'"
                              [inputId]="'maturityDateId'"
                              [inputValue]="machurityDate"
                              (inputValueEmit)="machurityDate=$event" 
                              [isRequired]="false"
                              [readOnly]="true">
                            </app-input>
                            </div>
                          </div>
                        </div>
                       </div>
                       <!-- end date section -->
                       <div class="col-2 gap-2 d-flex align-items-center mb-2">
                          <label for="inst_Type"
                            class="f-14 font-semibold  text-gray-color text-nowrap mb-0 ">
                            Inst. Type
                          </label>
                        <div class="col">
                          <app-input 
                            [inputName]="'inst.Type'" 
                            [inputType]="'text'"
                            [inputId]="'inst_Type'"
                            [inputValue]="getResponsEntryModel?.installmentTypeName"
                            (inputValueEmit)="getResponsEntryModel.installmentTypeName=$event" [isRequired]="false"
                            [readOnly]="true">
                          </app-input>
                        </div>
                      </div>
                      <!-- end inst type -->
                      <div class="col-6 gap-3 d-flex align-items-center ">
                          <label for="" class="f-14 font-semibold pe-2 text-gray-color text-nowrap mb-0 w-98px">
                            Address
                          </label>
                        <div class="col " style="padding-left: 46px;">
                          <app-input 
                            class="custom-width" 
                            [inputName]="'address'" 
                            [inputType]="'text'"
                            [inputId]="'addressid'" 
                            [inputValue]="customerAddress" 
                            (inputValueEmit)="customerAddress = $event"
                            [isRequired]="false" 
                            [readOnly]="true">
                          </app-input>
                        </div>
                      </div>
                      <!-- end address -->
                      <div class="col-4 ps-3 d-flex align-items-center">
                          <label 
                            class="f-14 font-semibold pe-2 text-gray-color text-nowrap mb-0 w-98px">
                            Redemption On
                          </label>
                        <div class="col pe-2">
                          <app-input 
                          [inputName]="'redemption'" 
                          [inputType]="'text'"
                          [inputId]="'redemptionId'"
                          [inputValue]="getResponsEntryModel?.redemptionOnName"
                          (inputValueEmit)="getResponsEntryModel.redemptionOnName=$event" 
                          [isRequired]="false"
                          [readOnly]="true">
                        </app-input>
                        </div>
                      </div>
                      <!--end  Redemption On -->
                      <div class="col-2 gap-2 d-flex align-items-center">
                          <label for="" class="f-14 font-semibold  text-gray-color text-nowrap mb-0 w-98px">
                            Inst. Amt.
                          </label>
                        <div class="col">
                          <app-input 
                            [inputClass]="'text-end'"
                            [inputName]="'instAmt'" 
                            [inputType]="'text'" 
                            [inputId]="'instAmtId'"
                            [inputValue]="getResponsEntryModel?.installmentAmount?.toFixed(2)"
                            (inputValueEmit)="getResponsEntryModel.installmentAmount = $event" 
                            [isRequired]="false"
                            [readOnly]="true">
                          </app-input>
                        </div>
                      </div>
                      <!--end   Inst. Amt. -->
                    </div>
              </form>
            </div>
            <div class="col-12 d-flex justify-content-center align-items-center" *ngIf="!isaddDetails">
              <div class="col-5 ps-3 pe-4 border-right d-flex">
                <div class="col-12 d-flex gap-4 my-1">
                  <div class="w-100px d-flex justify-content-start align-items-center">
                    <ng-container>
                      <div class="avatar">
                        <img alt="" [src]="isBase64Image(getDataModel?.photoUrl)" onerror="this.src = './assets/images/default.svg'"/>
                      </div>
                    </ng-container>
                    <img draggable="false" alt="">
                  </div>
                  <div class="col-8 h-100px">
                    <ng-container>
                      <div class="mt-2">
                        <h5 class="text-primary font-semibold f-16 mb-1">
                          {{getDataModel?.accountLedgerName}}
                        </h5>
                      </div>
                    </ng-container>
                    <div *ngIf="getDataModel?.fullAddress" for="productName" class="f-12 text-gray-color text-break w-98px">
                      {{ getFormattedAddress(getDataModel?.fullAddress) }}
                    </div>
                    <div class="col d-flex mb-1" [ngClass]="{'gap-3': getDataModel?.mobile && getDataModel?.email}">
                        <div class="d-flex justify-content-center align-items-center gap-2" *ngIf="getDataModel?.mobile"> 
                            <svg id="Group_2089" data-name="Group 2089" xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 10.657 10.661">
                              <path id="Path_1348" data-name="Path 1348" d="M-1243.76,1433.328a1.728,1.728,0,0,1,.736-1.539c.314-.221.629-.439.95-.649a.959.959,0,0,1,.921-.041,2.879,2.879,0,0,1,1.6,2.437.977.977,0,0,1-.457.855c-.184.119-.361.249-.548.363a.374.374,0,0,0-.182.512,6.726,6.726,0,0,0,.552,1.093,6.972,6.972,0,0,0,2.007,1.92,3.486,3.486,0,0,0,.31.174c.715.354.79.333,1.231-.33a1.241,1.241,0,0,1,1.662-.574,2.957,2.957,0,0,1,1.632,1.225,1.116,1.116,0,0,1-.017,1.4c-.168.216-.312.45-.468.676a1.885,1.885,0,0,1-1.968.786,6.488,6.488,0,0,1-2.714-1.119,13.449,13.449,0,0,1-4.605-4.973A5.01,5.01,0,0,1-1243.76,1433.328Zm8.305,7.728a1.179,1.179,0,0,0,1.126-.547c.158-.235.313-.473.482-.7a.551.551,0,0,0,.005-.686,2.366,2.366,0,0,0-1.353-1.011c-.492-.154-.647-.089-.938.343-.051.076-.1.154-.15.229a1.037,1.037,0,0,1-1.449.476,3.189,3.189,0,0,1-.354-.146,7.2,7.2,0,0,1-2.316-1.937,4.21,4.21,0,0,1-.939-1.715.929.929,0,0,1,.4-1.076,6.2,6.2,0,0,1,.525-.348.485.485,0,0,0,.253-.531,2.275,2.275,0,0,0-1.146-1.712.491.491,0,0,0-.588.035c-.212.158-.434.3-.656.448a1.321,1.321,0,0,0-.6,1.4,5.78,5.78,0,0,0,.946,2.374,13.122,13.122,0,0,0,4.51,4.356A4.834,4.834,0,0,0-1235.454,1441.056Z" transform="translate(1243.76 -1431.002)" fill="#008b70"/>
                              <path id="Path_1349" data-name="Path 1349" d="M-1151.526,1431.252a5.467,5.467,0,0,1,2.519,1.08,5.984,5.984,0,0,1,2.374,3.692c.009.045.017.09.023.135.026.2-.018.379-.251.41-.216.028-.287-.123-.344-.308a8.676,8.676,0,0,0-.518-1.521,5.332,5.332,0,0,0-3.849-2.882c-.2-.038-.368-.105-.35-.337C-1151.906,1431.308-1151.753,1431.234-1151.526,1431.252Z" transform="translate(1156.962 -1431.236)" fill="#008b70"/>
                              <path id="Path_1350" data-name="Path 1350" d="M-1151.395,1461.806c-.1.091-.176.226-.289.264-.169.057-.292-.053-.344-.227a6.421,6.421,0,0,0-.293-.937,3.917,3.917,0,0,0-2.841-2.271c-.2-.042-.362-.119-.328-.354s.209-.272.413-.243a4.645,4.645,0,0,1,3.62,3.609l.015.108Z" transform="translate(1160.337 -1456.546)" fill="#008b70"/>
                            </svg>                          
                          <div class="f-12  text-gray-color">{{getDataModel?.mobile}}</div>
                        </div>
                        <div class="d-flex justify-content-center align-items-center gap-2" *ngIf="getDataModel?.email">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 17.693 13.477">
                            <path id="Path_1365" data-name="Path 1365" d="M384.265,1882.286v-10.781c.011-.038.025-.076.034-.114a1.552,1.552,0,0,1,1.543-1.232q7.272,0,14.544,0a1.543,1.543,0,0,1,1.569,1.563q.006,5.173-.005,10.347a1.624,1.624,0,0,1-.156.68,1.516,1.516,0,0,1-1.477.886H386.291c-.167,0-.334,0-.5,0a1.551,1.551,0,0,1-.952-.352A1.712,1.712,0,0,1,384.265,1882.286Zm8.837-4.1,6.988-6.986H386.054Zm-7.019,4.392H400.12l-4.922-4.922c-.033.031-.079.073-.123.117q-.752.751-1.5,1.5a.534.534,0,0,1-.856,0q-.774-.765-1.545-1.533c-.044-.044-.09-.085-.128-.121Zm4.18-5.737-4.953-4.911v9.864Zm10.644,4.954v-9.809l-4.9,4.9Z" transform="translate(-384.265 -1870.157)" fill="#f76f11"/>
                          </svg>                          
                          <div class="f-12 text-break text-gray-color">
                            {{getDataModel?.email}}
                          </div>
                        </div>
                    </div>
                    <div class="">
                      <label *ngIf="formModel?.fundTransferId > 0 && !formModel?.fundUsedInInvoiceNo"
                        class="f-12 text-gray-color border-wrap fund-transfer text-nowrap mb-0">
                        Fund Transfer
                      </label>
                      <label *ngIf="formModel?.fundWithdrawId > 0 && formModel?.fundTransferId == 0 && !formModel?.fundUsedInInvoiceNo"
                        class="f-12 text-gray-color border-wrap fund-withdraw text-nowrap mb-0">
                        Fund Withdraw
                      </label>
                      <label *ngIf="formModel?.fundUsedInInvoiceNo" class="f-12 text-gray-color border-wrap fund-withdraw text-nowrap mb-0">
                        {{formModel?.fundUsedInInvoiceNo}}
                      </label>
                      <label *ngIf="selectedLedgerData?.isPickupDone" class="f-12 pickup border-wrap text-nowrap mb-0">
                        Picked
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col px-4 py-3">
                <div class="col-12 ">
                  <div class="col-11 mb-4 justify-content-center">
                    <div class="col-12  d-flex justify-content-center">
                      <div class="col-3">
                        <div>
                          <label for="productName" class="f-14  text-gray-color text-nowrap mb-0 w-98px">
                            Scheme Name:
                          </label>
                          <div class="col">
                            <h5 class="text-primary font-semibold f-13 mb-0">
                              {{getDataModel?.schemeName}}
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div class="col-3 ps-5">
                        <div>
                          <label for="productName" class="f-14 text-gray-color text-nowrap mb-0">
                            Joining Dt.:
                          </label>
                          <div class="col">
                            <h5 class="text-primary font-semibold f-13 mb-0">
                              {{getDataModel?.joiningDate | date: 'MM/dd/yyyy'}}
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div class="col-3 ps-5">
                        <div>
                          <label for="productName" class="f-14 text-gray-color text-nowrap mb-0">
                            Maturity Dt.:
                          </label>
                          <div class="col">
                            <h5 class="text-primary font-semibold f-13 mb-0">
                              {{getDataModel?.maturityDate | date: 'MM/dd/yyyy'}}
                            </h5>
                          </div>

                        </div>
                      </div>
                      <div class="col-3 ps-5 d-flex gap-3">
                        <div>
                          <label for="productName" class="f-14  text-gray-color text-nowrap mb-0">
                            Amount:
                          </label>
                          <div class="col">
                            <h5 class="text-primary font-semibold f-13 mb-0">
                              {{getDataModel?.installmentAmount | number: '1.2-2'}}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-11">
                    <div class="col-12  d-flex ">
                      <div class="col-3">
                        <label for="installmentType" class="f-14 text-gray-color text-nowrap mb-0 w-98px">
                          Installment Type:
                        </label>
                        <div class="col">
                          <h5 class="text-primary font-semibold f-13 mb-0">
                            {{getDataModel?.installmentTypeName}}
                          </h5>
                        </div>
                      </div>
                      <div class="col-3 ps-5">
                        <label for="duration" class="f-14  text-gray-color text-nowrap mb-0 w-98px">
                          Duration:
                        </label>
                        <div class="col">
                          <h5 class="text-primary font-semibold f-13 mb-0">
                            {{getDataModel?.durationInFormat}}
                          </h5>
                        </div>
                      </div>
                      <div class="col-3 ps-5">
                        <label for="redemptionOn" class="f-14  text-gray-color text-nowrap mb-0 w-98px">
                          Redemption On:
                        </label>
                        <div class="col">
                          <h5 class="text-primary font-semibold f-13 mb-0">
                            {{getDataModel?.redemptionOnName}}
                          </h5>
                        </div>
                      </div>
                      <div class="col-3 ps-5 d-flex gap-3">
                        <div>
                          <label for="advancedPayment" class="f-14  text-gray-color text-nowrap mb-0">
                            Advanced Payment:
                          </label>
                          <div class="col">
                            <h5 class="text-pink font-semibold f-13 mb-0">
                              {{getDataModel?.advancePayment | number: '1.2-2'}}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!----Installment Entry Form------->
            <div class="col-12 px-0">
              <hr class="mt-0  py-0">
            </div>
            <div class="col-6 d-flex align-items-center gap-1 font-semibold f-16">
              <div class="text-primary"> Installment Entry</div>
              <div class="text-pink cursorPointer" *ngIf="selectedLedgerData?.againstInvoiceNo"
                (click)="navigateToagainstInvoiceNo()">({{selectedLedgerData?.againstInvoiceNo }})</div>
            </div>
            <div class="col-6 px-0 d-flex justify-content-end align-items-center ngbNav-tabs">
              <ul ngbNav #nav="ngbNav" class="nav-tabs justify-content-between flow-hidden" [(activeId)]="activeTabId" (navChange)="onTabChange($event)">
                <li [ngbNavItem]="1" [disabled]="isTab2Enabled">
                  <a ngbNavLink class="d-flex">
                    <span class="d-flex justify-content-center f-16 font-semibold px-0">Normal</span>
                  </a>
                </li>
                <li [ngbNavItem]="2" [disabled]="isTab2Enabled">
                  <a ngbNavLink class="d-flex">
                    <span class="d-flex justify-content-center f-16 font-semibold px-0">Passbook</span>
                  </a>
                </li>
              </ul>
            </div>
            <div class="col-12 px-0 mt-1" *ngIf="activeTabId==installmentEntries.Passbook">
              <app-ag-grid 
                id="addEntry" 
                [class]="['all_aggrid_tables', 'position-relative', 'd-block', isaddDetails ? 'h-450' : 'h-400'].join(' ')" 
                [rowData]="formModel?.passbookList"
                [dataModel]="agGridDataModelAddEntry" 
                [gridOptions]="gridOptions"
                (gridReady)="onGridReady($event)"
                [columnSettings]="true"
                (onDeleteIconClick)="onDeleteIconClick($event)"
                (onCardPaymentIconClick)= "onCardPaymentIconClick($event)"
                [headerHeight]="28">
              </app-ag-grid>
            </div>
            <div class="col-12 px-0 mt-1" *ngIf="activeTabId==installmentEntries.Normal">
              <app-ag-grid 
                id="addEntrys" 
                [class]="['all_aggrid_tables', 'position-relative', 'd-block', isaddDetails ? 'h-450' : 'h-400'].join(' ')" 
                [dataModel]="agGridDataModelNormal"    
                [rowData]="formModel?.normalList"           
                (gridReady)="onGridadreadyNormaltab($event)" 
                [columnSettings]="true"
                [gridOptions]="gridOptionsTaxSetting"
                (onDeleteIconClick)="onDeleteIconClick($event)"
                (onPrintButtonClick)="printButtonClick($event)"
                (onCardPaymentIconClick)= "onCardPaymentIconClick($event)"
                [headerHeight]="28">
              </app-ag-grid>
            </div>
         
          </div>
        </div>
      </div>
      <div class="card border radius-0 card-border">
        <div class="card-body px-2 py-2">
          <form class="d-flex justify-content-between gap-3">
            <div class="d-flex gap-2">
              <label for="" class="f-14 font-semibold  mt-1 text-gray-color text-nowrap mb-0 w-98px">
                Paid Inst.
              </label>
              <app-input 
              [inputName]="'paidInstallment'" 
              [inputType]="'text'" 
              [inputId]="'paidInstallmentID'"
              [inputValue]="formModel?.footerCalculation?.paidInstallments" 
              (inputValueEmit)="formModel.footerCalculation.paidInstallments = $event" 
              [readOnly]="true">
              </app-input>
            </div>
            <div class="d-flex gap-2">
              <label for="" class="f-14 font-semibold  mt-1 text-gray-color text-nowrap mb-0 w-98px">
                Paid Amount
              </label>
              <app-input 
               onlyNumbers 
                [inputClass]="'text-end'"
                [inputName]="'paidAmount'" 
                [inputType]="'text'" 
                [inputId]="'paidAmountId'"
                [decimalPlaces]="2"
                [inputValue]="formModel?.footerCalculation?.paidAmount?.toFixed(2)" 
                (inputValueEmit)="formModel.footerCalculation.paidAmount= $event" [readOnly]="true">
              </app-input>
            </div>
            <div class="d-flex gap-2">
              <label for="" class="f-14 font-semibold  mt-1 text-gray-color text-nowrap mb-0 w-98px">
                Remaining Amt.
              </label>
              <app-input 
              onlyNumbers 
              [inputClass]="'text-end'"
              [inputName]="'remainingAmt'" 
              [inputType]="'text'" 
              [decimalPlaces]="2"
              [inputId]="'remainingAmtId'"
              [inputValue]="formModel?.footerCalculation?.remainingAmount?.toFixed(2)" 
              (inputValueEmit)="formModel.footerCalculation.remainingAmount=$event" [readOnly]="true">
              </app-input>
            </div>
            <div class="d-flex gap-2">
              <label for="" class="f-14 font-semibold  mt-1 text-gray-color text-nowrap mb-0 w-98px">
                Total Amount
              </label>
              <app-input 
              onlyNumbers 
              [inputClass]="'text-end'"
              [inputName]="'totalAmount'" 
              [inputType]="'text'"
              [inputId]="'totalAmountId'"
              [inputValue]="formModel?.footerCalculation?.totalAmount.toFixed(2)" 
              [decimalPlaces]="2"
              (inputValueEmit)="formModel.footerCalculation.totalAmount= $event" [readOnly]="true">
              </app-input>
            </div>
            <div class="d-flex gap-2">
              <label for="" class="f-14 font-semibold  mt-1 text-gray-color text-nowrap mb-0 w-98px">
                Gold Wt.
              </label>
              <app-input 
              [inputClass]="'text-end'"
              [inputName]="'goldWt'" 
              [inputType]="'text'" 
              [inputId]="'goldWt'" 
              [inputValue]="formModel?.footerCalculation?.goldWt.toFixed(3)"
              [decimalPlaces]="3"
              (inputValueEmit)="formModel.footerCalculation.goldWt=$event" 
              [readOnly]="true">
              </app-input>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #contents let-modal>
  <div class="modal-body pt-4 pb-4">
      <div class="row">
          <div class="col-12 d-flex justify-content-center mb-4">
              <img src="./assets/SVGicon/delete-confirm-icon.svg" alt="">
          </div>
          <div class="col-12 ">
              <div class="d-flex justify-content-center">
                  <h5 class="text-gray-color f-16 mb-0  font-semibold ">Deleting {{params?.getParamasData}}</h5>
              </div>
              <div class="d-flex justify-content-center">
                  <p class="theme-color-secondary f-13 w-p-200 mt-1 text-center font-regular mb-0">Are you sure you want to delete {{params?.getParamasData}} from this list</p>
              </div>
          </div>
      </div>
  </div>
  <div class="modal-footer d-block">
      <div class="row m-0">
          <div class="col-6 border-right d-flex justify-content-center align-items-center">
              <label class="f-14 font-semibold cursorPointer py-2 mb-0 text-gray-color" (click)="modal.dismiss('Cross click')">CANCEL</label>
          </div>
          <div class="col-6 d-flex justify-content-center align-items-center">
              <label class="f-14 font-semibold cursorPointer py-2 mb-0 text-danger"  (click)="deleterowdata(params,modal)">DELETE</label>
          </div>
      </div>
  </div>
</ng-template>